module.exports = __webpack_public_path__ + "img/Kibe21.7419d000.jpg";